import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "beta",
    aws_cognito_region: "us-east-1",
    aws_cognito_identity_pool_id: "us-east-1:cbb92afc-e464-4133-b032-4ac8c73b730d",
    aws_user_pools_id: "us-east-1_RzY5aiHXO",
    aws_user_pools_web_client_id: "3llqj156u0k4n5sk130v1mkc71",
    Auth: {
      identityPoolId: "us-east-1:cbb92afc-e464-4133-b032-4ac8c73b730d",
      region: "us-east-1",
      userPoolId: "us-east-1_RzY5aiHXO",
      userPoolWebClientId: "3llqj156u0k4n5sk130v1mkc71",
    },
    oauth: {
      domain: "whs-safer-beta-na.auth.us-east-1.amazoncognito.com",
      redirectSignIn: "https://beta.na.safer.whs.amazon.dev",
      redirectSignOut: "https://beta.na.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };

  // BETA/LOCAL ONLY: the Hydra/Cypress integration test authenticates as a SAAM
  // service identity (svc-mw-...-midwaysaam) that has NO email. The identity
  // pool's authenticated role (AmazonQBusinessCognitoRole) requires an `Email`
  // session tag mapped from the token's `email` claim; with no email, the role
  // assume fails ("Invalid identity pool configuration") and Amplify emits
  // signIn_failure so the app never authenticates. The frontend does not use
  // identity-pool (IAM) credentials, so we drop the identity pool on beta/local
  // and let sign-in complete on the User Pool alone. Gamma/prod are unchanged.
  // Local/dev builds resolve beta to "test".
  const stage = "beta".toLowerCase();
  const skipIdentityPool = stage === "beta" || stage === "test";

  if (skipIdentityPool) {
    delete (config as { aws_cognito_identity_pool_id?: string })
      .aws_cognito_identity_pool_id;
    delete (config.Auth as { identityPoolId?: string }).identityPoolId;
  }

  Auth.configure(config);
}
